<template>
    <div class="contents">
        <ToastProvider>
            <Header ref="header"></Header>
              <AddToCartToast
                v-show="isMobile"
                class="add-to-cart-toast fixed z-[99999999] right-[3.5%]"
                :style="{ top: `${computedTop}px` }"
                />
            <slot />
            <Footer></Footer>
            <Toast></Toast>
        </ToastProvider>
    </div>
  <SalesforceChat v-if="showSalesforceChat"/>
    <AIChatPopupModal  />
</template>

<script setup lang="ts">
import {ToastProvider} from 'radix-vue';
import Header from '~/components/header.vue';
import Footer from '~/components/footer.vue';
import Toast from '~/components/toast.vue';
import AIChatPopupModal from '~/components/ui/organism/AIChatPopupModal.vue';
import AddToCartToast from "~/components/AddToCartToast.vue";
import SalesforceChat from '~/vendors/salesforceChat.vue'
import { ref, computed } from 'vue';
import { useIframeStore } from '~/stores/chatAIStore';
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';


const iframeStore = useIframeStore();
const { annonceMentHeight} = storeToRefs(iframeStore);
const breakPoints = useBreakpoints(breakpointsTailwind);
const isMobileBreakpoint = breakPoints.smaller('md'); 
const isMobile = ref(isMobileBreakpoint.value);

const computedTop = computed(() => {
  return (annonceMentHeight.value || 0) + 50;
});
const route = useRoute();
const allowedSalesforceChatPaths = ['/faq']; // Add more path prefixes here as needed

const showSalesforceChat = computed(() => {
  return allowedSalesforceChatPaths.some(prefix => route.path.startsWith(prefix));
});
</script>
